import {differenceInCalendarDays} from 'date-fns';
import {toDate} from './date';

// `end` is stored as the end of the expiration day, so only the day matters:
// an endpoint stays available for the whole of its last day.
export const isEndpointExpired = (endpoint) =>
    !!endpoint.end && differenceInCalendarDays(toDate(endpoint.end), new Date()) < 0;

const isEndpointSoldOut = (endpoint) =>
    endpoint.quantity === 0 || isEndpointExpired(endpoint);

export default isEndpointSoldOut;
